import { TranslationKey } from 'state/intl/types';

export const HEADER_IDS: Record<string, TranslationKey> = {
  POINTS: 'perks',
  PURCHASE_AMOUNT: 'purchaseAmount',
};
